import { render } from "./TermsConditionsPage.vue?vue&type=template&id=f8e8cd14&ts=true"
import script from "./TermsConditionsPage.vue?vue&type=script&lang=ts"
export * from "./TermsConditionsPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__